import { CellId, ExploreSpec } from "@hex/common";
import { shallowEqual } from "react-redux";

import {
  useCellContentsGetter,
  useCellContentsSelector,
} from "../../hex-version-multiplayer/state-hooks/cellContentsStateHooks.js";

export function useExploreSpecSelector<T>(
  cellId: CellId,
  selector: (spec: ExploreSpec) => T,
): T {
  return useCellContentsSelector({
    cellId,
    selector: (contents) => {
      if (contents.__typename !== "ExploreCell") {
        throw new Error(`Expected ExploreCell, got ${contents.__typename}`);
      }
      return selector(contents.spec);
    },
    equalityFn: shallowEqual,
  });
}

export function useExploreSpecGetter<T>(
  selector: (spec: ExploreSpec) => T,
): (cellId: CellId) => T {
  return useCellContentsGetter({
    selector: (contents) => {
      if (contents.__typename !== "ExploreCell") {
        throw new Error(`Expected ExploreCell, got ${contents.__typename}`);
      }
      return selector(contents.spec);
    },
  });
}
